import { create } from 'zustand';

interface ContestFiltersState {
  search: string;
  status: string;
  sortBy: string;
  setSearch: (search: string) => void;
  setStatus: (status: string) => void;
  setSortBy: (sortBy: string) => void;
  reset: () => void;
}

export const useContestFilters = create<ContestFiltersState>((set) => ({
  search: '',
  status: '',
  sortBy: '',
  setSearch: (search) => set({ search }),
  setStatus: (status) => set({ status }),
  setSortBy: (sortBy) => set({ sortBy }),
  reset: () => set({ search: '', status: '', sortBy: '' }),
}));
